const NO_DECOMPOSITION_FORM_CHARACTERS: Record<string, string> = {
  ß: 'ss',
  ø: 'o',
}

export const normalizeString = (text: string | undefined): string | undefined => {
  if (!text) {
    return text
  }

  const normalizedText = text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
  let replacedNoDecompositionFormCharacters = normalizedText

  Object.keys(NO_DECOMPOSITION_FORM_CHARACTERS).forEach((key) => {
    replacedNoDecompositionFormCharacters = replacedNoDecompositionFormCharacters.replaceAll(
      key,
      NO_DECOMPOSITION_FORM_CHARACTERS[key],
    )
  })

  return replacedNoDecompositionFormCharacters
}
